import { render } from "./DaysOffModal.vue?vue&type=template&id=c04c92b6"
import script from "./DaysOffModal.vue?vue&type=script&lang=js"
export * from "./DaysOffModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__